"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _noop = _interopRequireDefault(require("lodash/noop"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _Icon = _interopRequireDefault(require("../../Icon/Icon.index"));

var _Gallery = require("../Gallery.types");

var _Thumbnail = require("./Thumbnail.styles");

var Thumbnail = function Thumbnail(_ref) {
  var _theme$gallery, _theme$gallery$thumbn, _theme$gallery$thumbn2, _theme$gallery$thumbn3, _theme$gallery2, _theme$gallery2$thumb, _theme$gallery2$thumb2, _theme$gallery$thumbn4, _theme$gallery3, _theme$gallery3$thumb, _theme$gallery3$thumb2;

  var description = _ref.description,
      src = _ref.src,
      srcSet = _ref.srcSet,
      sizes = _ref.sizes,
      mediaType = _ref.mediaType,
      selected = _ref.selected,
      remaining = _ref.remaining,
      theme = _ref.theme,
      onClick = _ref.onClick,
      onMouseEnter = _ref.onMouseEnter,
      showSkeleton = _ref.showSkeleton,
      onImageLoaded = _ref.onImageLoaded;
  return /*#__PURE__*/_react["default"].createElement(_Thumbnail.ThumbnailBase, {
    selected: selected,
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    role: "button",
    showSkeleton: showSkeleton,
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: "Thumbnail - ".concat(description),
    src: src,
    srcSet: srcSet,
    sizes: sizes,
    onLoad: onImageLoaded
  }), mediaType === 'VIDEO' && /*#__PURE__*/_react["default"].createElement(_Thumbnail.PlayIcon, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    size: "auto",
    name: theme === null || theme === void 0 ? void 0 : (_theme$gallery = theme.gallery) === null || _theme$gallery === void 0 ? void 0 : (_theme$gallery$thumbn = _theme$gallery.thumbnail) === null || _theme$gallery$thumbn === void 0 ? void 0 : (_theme$gallery$thumbn2 = _theme$gallery$thumbn.video) === null || _theme$gallery$thumbn2 === void 0 ? void 0 : _theme$gallery$thumbn2.icon,
    color: (_theme$gallery$thumbn3 = theme === null || theme === void 0 ? void 0 : (_theme$gallery2 = theme.gallery) === null || _theme$gallery2 === void 0 ? void 0 : (_theme$gallery2$thumb = _theme$gallery2.thumbnail) === null || _theme$gallery2$thumb === void 0 ? void 0 : (_theme$gallery2$thumb2 = _theme$gallery2$thumb.video) === null || _theme$gallery2$thumb2 === void 0 ? void 0 : _theme$gallery2$thumb2.color) !== null && _theme$gallery$thumbn3 !== void 0 ? _theme$gallery$thumbn3 : '#fff'
  })), remaining > 0 && /*#__PURE__*/_react["default"].createElement(_Thumbnail.Remaining, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement("span", null, (_theme$gallery$thumbn4 = theme === null || theme === void 0 ? void 0 : (_theme$gallery3 = theme.gallery) === null || _theme$gallery3 === void 0 ? void 0 : (_theme$gallery3$thumb = _theme$gallery3.thumbnail) === null || _theme$gallery3$thumb === void 0 ? void 0 : (_theme$gallery3$thumb2 = _theme$gallery3$thumb.remaining) === null || _theme$gallery3$thumb2 === void 0 ? void 0 : _theme$gallery3$thumb2.text) !== null && _theme$gallery$thumbn4 !== void 0 ? _theme$gallery$thumbn4 : "".concat(remaining, "+"))));
};

Thumbnail.propTypes = {
  src: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].string,
  srcSet: _propTypes["default"].string,
  sizes: _propTypes["default"].string,
  mediaType: _propTypes["default"].oneOf(['IMAGE', 'VIDEO']),
  selected: _propTypes["default"].bool,
  remaining: _propTypes["default"].number,
  theme: _Gallery.galleryTheme,
  onClick: _propTypes["default"].func,
  onMouseEnter: _propTypes["default"].func,
  showSkeleton: _propTypes["default"].bool,
  onImageLoaded: _propTypes["default"].func
};
Thumbnail.defaultProps = {
  description: undefined,
  srcSet: undefined,
  sizes: undefined,
  mediaType: 'IMAGE',
  selected: false,
  remaining: -1,
  theme: undefined,
  onClick: _noop["default"],
  onMouseEnter: _noop["default"],
  showSkeleton: false,
  onImageLoaded: _noop["default"]
};
Thumbnail.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Thumbnail",
  "props": {
    "description": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "srcSet": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "sizes": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "mediaType": {
      "defaultValue": {
        "value": "'IMAGE'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'IMAGE'",
          "computed": false
        }, {
          "value": "'VIDEO'",
          "computed": false
        }]
      },
      "required": false
    },
    "selected": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "remaining": {
      "defaultValue": {
        "value": "-1",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "theme": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "custom",
        "raw": "galleryTheme"
      },
      "required": false
    },
    "onClick": {
      "defaultValue": {
        "value": "noop",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onMouseEnter": {
      "defaultValue": {
        "value": "noop",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "showSkeleton": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onImageLoaded": {
      "defaultValue": {
        "value": "noop",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "src": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};

var _default = (0, _styledComponents.withTheme)(Thumbnail);

exports["default"] = _default;